/* eslint-disable react-hooks/exhaustive-deps */
import type React from 'react';
import { useEffect } from 'react';
import useSelectionCursor, { type SelectionCursor } from './useSelectionCursor';
import useKeydownListener from '@/lib/utils/useKeydownListener';
import { type User } from '@/lib/types';

const useResultListKeyboardNavigation = (
  inputRef: React.RefObject<HTMLInputElement | null>,
  selectableUsers: User[],
  onSelectUser: (user: User) => void,
  onKeyboardSelectUser: (email: string | null) => void,
): SelectionCursor => {
  const selectionCursor = useSelectionCursor(selectableUsers);
  const keyboardSelectedUser =
    selectionCursor.index === null
      ? null
      : (selectableUsers[selectionCursor.index] ?? null);

  // eslint-disable-next-line react-hooks/refs
  useKeydownListener(inputRef.current, event => {
    if (event.key === 'ArrowUp') {
      selectionCursor.moveUp();
    }

    if (event.key === 'ArrowDown') {
      selectionCursor.moveDown();
    }

    if (event.key === 'Enter' && keyboardSelectedUser) {
      onSelectUser(keyboardSelectedUser);
    }
  });

  // eslint-disable-next-line react-hooks/refs
  const inputHasFocus = inputRef.current === document.activeElement;

  useEffect(() => {
    if (!inputHasFocus) {
      selectionCursor.clear();
    }
  }, [inputHasFocus]);

  useEffect(() => {
    onKeyboardSelectUser(keyboardSelectedUser?.email ?? null);
  }, [selectionCursor.index]);

  return selectionCursor;
};

export default useResultListKeyboardNavigation;
